// extracted by mini-css-extract-plugin
module.exports = {"bundle":"bundle_bundle__xXJ6s","trash":"bundle_trash__CDEtf"};